import React from 'react'
import styles from './UIGamePlayerInfoSectionContent.module.scss'
import {UIGamePlayerInfoSectionImageWithCount} from '../../UIGamePlayerInfoSectionImageWithCount/UIGamePlayerInfoSectionImageWithCount'
import {PlayerColor} from '@colonist/game-states'
import {ROAD_IMAGE_PATH} from '../../../../../core/UIGameActionButtonsContainer/UIGameActionButtonRoad/utils'
import {SETTLEMENT_IMAGE_PATH} from '../../../../../core/UIGameActionButtonsContainer/UIGameActionButtonSettlement/utils'
import {CITY_IMAGE_PATH} from '../../../../../core/UIGameActionButtonsContainer/UIGameActionButtonCity/utils'
import {SHIP_IMAGE_PATH} from '../../../../../core/UIGameActionButtonsContainer/UIGameActionButtonShip/utils'
import {CITY_WALL_IMAGE_PATH} from '../../../../../core/UIGameActionButtonsContainer/UIGameActionButtonCityWall/utils'
import {Tooltip, T} from '@colonist/ui'

export interface UIGamePlayerInfoSectionContentPiecesProps {
    playerColor: PlayerColor
    roadCount?: number | undefined
    settlementCount?: number | undefined
    cityCount?: number | undefined
    shipCount?: number | undefined
    cityWallCount?: number | undefined
}

export const UIGamePlayerInfoSectionContentPieces = ({
    playerColor,
    roadCount,
    settlementCount,
    cityCount,
    shipCount,
    cityWallCount,
}: UIGamePlayerInfoSectionContentPiecesProps) => {
    const roadIcon = ROAD_IMAGE_PATH[playerColor]
    const settlementIcon = SETTLEMENT_IMAGE_PATH[playerColor]
    const cityIcon = CITY_IMAGE_PATH[playerColor]
    const shipIcon = SHIP_IMAGE_PATH[playerColor]
    const cityWallIcon = CITY_WALL_IMAGE_PATH[playerColor]

    return (
        <div className={styles.container}>
            {roadCount !== undefined && <Tooltip
                title={<T id='strings:game.PieceTypes.Road'/>}>
                <UIGamePlayerInfoSectionImageWithCount
                    piece={roadIcon}
                    count={roadCount}
                    size='sm' />
            </Tooltip>}
            {settlementCount !== undefined && <Tooltip
                title={<T id='strings:game.PieceTypes.Settlement'/>}>
                <UIGamePlayerInfoSectionImageWithCount
                    piece={settlementIcon}
                    count={settlementCount}
                    size='sm' />
            </Tooltip>}
            {cityCount !== undefined && <Tooltip
                title={<T id='strings:game.PieceTypes.City'/>}>
                <UIGamePlayerInfoSectionImageWithCount
                    piece={cityIcon}
                    count={cityCount}
                    size='sm' />
            </Tooltip>}
            {shipCount !== undefined && <Tooltip
                title={<T id='strings:game.PieceTypes.Ship'/>}>
                <UIGamePlayerInfoSectionImageWithCount
                    piece={shipIcon}
                    count={shipCount}
                    size='sm' />
            </Tooltip>}
            {cityWallCount !== undefined && <Tooltip
                title={<T id='strings:game.PieceTypes.CityWall'/>}>
                <UIGamePlayerInfoSectionImageWithCount
                    piece={cityWallIcon}
                    count={cityWallCount}
                    size='sm' />
            </Tooltip>}
        </div>
    )
}
